import {Box, Pagination, SpaceBetween, Cards, TextFilter} from "@cloudscape-design/components";
import {useCollection} from "@cloudscape-design/collection-hooks";
import {getTextFilterCounterText} from "./propertyFilter";


const NoMatchState = props => (
    <Box margin={{ vertical: 'xs' }} textAlign="center" color="inherit">
        <SpaceBetween size="xxs">
            <div>
                <b>No matches</b>
                <Box variant="p" color="inherit">
                    Your search did not match any results. Try a different search term.
                </Box>
            </div>
        </SpaceBetween>
    </Box>
)

const EmptyState = ({title, subtitle}) => (
    <Box margin={{ vertical: 'xs' }} textAlign="center" color="inherit">
        <SpaceBetween size="xxs">
            <div>
                <b>{title}</b>
                <Box variant="p" color="inherit">
                    {subtitle}
                </Box>
            </div>
        </SpaceBetween>
    </Box>
)

export const CollectionsCards = (props) => {
    const {
        items,
        actions,
        filteredItemsCount,
        collectionProps,
        filterProps,
        paginationProps
    } = useCollection(
            props.data,
    {
                filtering: {
                    empty: <EmptyState title={props.texts.emptyTitle} subtitle={props.texts.emptyMessage}/>,
                    noMatch: <NoMatchState onClearFilter={() => actions.setFiltering('')}/>
                },
                pagination: {pageSize: 10},
                selection: {},
            }
        );

    return (
        <Cards
            {...collectionProps}
            {...props}
            loadingText={props.texts.loadingText}
            items={items}
            pagination={<Pagination{...paginationProps} disabled={props.loading}/>}
            filter={
                <TextFilter
                    {...filterProps}
                    filteringAriaLabel="Filter architectures"
                    filteringPlaceholder="Find architectures"
                    filteringClearAriaLabel="Clear"
                    countText={getTextFilterCounterText(filteredItemsCount)}
                    disabled={props.loading}
                />
            }
        />
    );
}